import React from "react";
import "./CSS/camp.css";
import img from "./images/recapr.png";
import imge from "./images/Tech.png";
import broc from "./images/Finalized_Print_Copy.pdf";


export default function camp() {
  return (
    <div className="container">
      <section className="home">
        <div className="land">
          <div className="logo">
            <a href="/">
            <img
              src={imge}
              alt="Logo"
              style={{ width: "200px", height: "60%" }}
            />
           </a>
            <img
              src={img}
              alt="Logo"
              style={{ width: "200px", height: "100%" }}
            />
          </div>
           <h1>CELEBRATING INNOVATION <br /> THIS SUMMER!</h1>
           <button className="brochure"  onClick={() => window.open(broc, "_blank")}>Download Brochure</button>
        </div>

      </section>
     
      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero-left">          
          <p>
            <strong>Technotharanga</strong> in association with <strong>Recap Engineering Solutions</strong> invites the brightest minds of Tumakuru to the Future Technologies Masterclass Screies. Shape your roadmap in <strong>AI & Robotics</strong> - Join us for an exlusive preview and live demo at our center!
          </p>

          <div className="highlight-box">
            <h2>DECODING THE FUTURE <br/>
            Robootics & AI for young minds
            </h2>
          </div>

          <p className="tagline">
            Showcase your Innovations. Win Certificates. Get shortlisted for the Masterclass Series.
          </p>
        </div>

        <div className="hero-right">
          <img
            src="/Robot.png"
            alt="Innovation"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </section>

      {/* WHO CAN PARTICIPATE */}
      <section className="section">
        <h2 className="section-title">WHO CAN PARTICIPATE</h2>
        <ul className="icon-list-1">
          <li><strong>Engineering Students:</strong> All Branches</li>
          <li><strong>IT & Science Students:</strong> BCA, MCA, BSc, MSc</li>
          <li><strong>School Students:</strong> Robotics, Science Models</li>
          <li><strong>Coding Enthusiasts:</strong> Apps, Websites, Software Prototypes</li>
        </ul>
      </section>

      {/* WHY PARTICIPATE */}
      <section className="section two-col">
        <div>
          <h2 className="section-title">WHY PARTICIPATE</h2>
          <ul className="icon-list">
            <li> Innovation Excellence Awards</li>
            <li> Global Tech Recognition</li>
            <li> Expert Mentorship</li>
            <li> Masterclass Credentials</li>
          </ul>
        </div>

        <div>
          <h2 className="section-title">THE SCHEDULE</h2>
          <p><strong>April 10th (5pm):</strong> Registration  Deadline</p>
          <p><strong>Feb 16th - April 16th:</strong> Exclusive Masterclass Sessions</p>
          <p><strong>April 15th:</strong> Project Selection & Preview</p>
          <p><strong>April 16th:</strong> Grand Showcase & Launch</p>
        </div>
      </section>

      {/* REGISTER SECTION */}
      <section className="register">
        <div className="qr">
          <img src="/QR.png" alt="QR Code" />
          <p>Scan to Register</p>
          <p> ( OR )</p>
          <button onClick={() => window.open("https://docs.google.com/forms/d/1hDnJxbywPn7EOV4oGOc2CGKlk72VKxovxSvFB1OGrtA/edit?pli=1", "_blank")}>Register Now</button>
        </div>

        <div>
          <h2>REGISTER NOW</h2>
          <p>
            Our Office Locations
          </p>

          <p className="location">
            <strong>Location 1 -</strong> Technotharanga Solutions Pvt Ltd, JBA Arcade, 2st Floor, 1st Cross, Ashoka Nagar, Tumakuru<br/>
            <strong>Location 2 -</strong> Recap Engineering Solutions, 2nd Cross, Mahalakshmi Nagara, Gubbi Town, Gubbi
          </p>

          <p className="contact">
            <strong>Contact for Queries:</strong> +91 7795558001, 7892880022
          </p>
        </div>

        
      </section>

      {/* FOOTER */}
      <footer>
        <p className="foot"> &copy; 2026 Technotharanga Solutions Pvt Ltd. All rights reserved.</p>
      </footer>

    </div>
  );
}
